import Marquee from "react-fast-marquee";
import { Asterisk } from "@phosphor-icons/react";
import { MARQUEE_ITEMS } from "../../i18n/content";

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-black/10 py-5 md:py-6 select-none overflow-hidden"
    aria-hidden="true"
  >
    <Marquee speed={28} gradient={false} pauseOnHover={false}>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-cabinet font-medium text-lg md:text-xl tracking-[0.2em] uppercase text-black/35 px-6 md:px-10">
            {item}
          </span>
          <Asterisk size={18} weight="bold" className="text-brand-red/50" />
        </span>
      ))}
    </Marquee>
  </div>
);
